import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import Avatar from './Avatar';

// Thin, tap-to-expand summary of the last 7 days' points — sits under the
// household banner on the Chores tab so the full folder list still owns the
// screen. The Analytics tab carries the real depth (ranges, charts, history).
const ScoreboardStrip = ({ standings, total }) => {
  const [expanded, setExpanded] = useState(false);

  if (standings.length === 0) return null;

  return (
    <div
      onClick={() => setExpanded(e => !e)}
      className="-mt-6 mb-3 p-3 rounded-2xl bg-ink-card border border-white/10 cursor-pointer"
    >
      <div className="flex items-center justify-between">
        <span className="text-[10px] font-mono font-medium text-ink-fg/40 uppercase tracking-widest">7 Days</span>
        <div className="flex items-center gap-3">
          {standings.slice(0, 4).map(p => (
            <div key={p.id} className="flex items-center gap-1.5">
              <div className="w-1.5 h-1.5 rounded-sm flex-shrink-0" style={{ backgroundColor: p.color || 'oklch(0.72 0.155 48)' }} />
              <span className="text-[10.5px] font-mono font-medium text-ink-fg/75">{p.points}</span>
            </div>
          ))}
          {expanded ? <ChevronDown size={14} className="text-ink-fg/40" /> : <ChevronRight size={14} className="text-ink-fg/40" />}
        </div>
      </div>
      <div className="flex h-1.5 rounded-full overflow-hidden mt-2.5 gap-0.5">
        {standings.map(p => (
          <div
            key={p.id}
            style={{
              width: `${total > 0 ? (p.points / total) * 100 : 100 / standings.length}%`,
              backgroundColor: p.color || 'oklch(0.72 0.155 48)',
            }}
          />
        ))}
      </div>
      {expanded && (
        <div className="mt-3 pt-3 border-t border-white/10 space-y-2" onClick={(e) => e.stopPropagation()}>
          {standings.map((p, idx) => (
            <div key={p.id} className="flex items-center gap-3">
              <span className="text-[10px] font-bold w-4 text-ink-fg/40">{idx + 1}</span>
              <Avatar user={p} size="w-6 h-6" textSize="text-[10px]" />
              <span className="flex-1 text-sm font-semibold text-ink-fg/90 truncate">{p.name}</span>
              <span className="text-sm font-mono font-bold text-mint">{p.points}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ScoreboardStrip;
